import { HexId, SalesUpsellFeatureGates } from "@hex/common";
import { PayloadAction, createSlice } from "@reduxjs/toolkit";

import { OnboardingDialogId } from "../../components/tour/dialogs";

export type ContactSalesVariant =
  | SalesUpsellFeatureGates
  | "CTA_PRICING_PAGE"
  | "CTA_TRIAL_BANNER";

type UiSliceState = {
  contactSalesFormOpen: ContactSalesVariant | null;
  onboardingDialog: {
    id: OnboardingDialogId;
    hexId: HexId;
    properties?: {
      context?: "created-dc" | "dismissed-dc" | "skipped-ai";
    };
  } | null;
};

const initialState: UiSliceState = {
  contactSalesFormOpen: null,
  onboardingDialog: null,
};

const UiSlice = createSlice({
  name: "Ui",
  initialState,
  reducers: {
    setContactSalesFormOpen: (
      state,
      action: PayloadAction<ContactSalesVariant>,
    ) => {
      state.contactSalesFormOpen = action.payload;
    },
    closeContactSalesForm: (state) => {
      state.contactSalesFormOpen = null;
    },
    setOnboardingDialog: (
      state,
      action: PayloadAction<NonNullable<UiSliceState["onboardingDialog"]>>,
    ) => {
      state.onboardingDialog = action.payload;
    },
    closeOnboardingDialog: (state) => {
      state.onboardingDialog = null;
    },
  },
});

export const uiReducer = UiSlice.reducer;
export const {
  closeContactSalesForm,
  closeOnboardingDialog,
  setContactSalesFormOpen,
  setOnboardingDialog,
} = UiSlice.actions;

export const selectUi = (state: { ui: UiSliceState }): UiSliceState => state.ui;
